import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxQRCodeModule } from 'ngx-qrcode2';

import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Setup2faComponent } from './2fa/setup-2fa.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { EulaComponent } from './click-through-license/eula.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgxQRCodeModule
  ],
  declarations: [
    LoginComponent,
    LogoutComponent,
    Setup2faComponent,
    ChangePasswordComponent,
    EulaComponent,
  ],
})
export class AuthModule { }
